import React from 'react';
import {
  FeaturesContainer,
  FeaturesContent,
  TitleContainer,
  Title,
  TitleArrow,
  CardsContainer,
  FeatureCard,
  IconContainer,
  FeatureTitle,
  FeatureDescription
} from './styles';

// Ícones SVG inline
const PaymentIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="12" width="40" height="24" rx="4" stroke="#FF7A00" strokeWidth="2" fill="none"/>
    <path d="M4 20h40" stroke="#FF7A00" strokeWidth="2"/>
    <rect x="8" y="28" width="8" height="4" rx="2" fill="#FF7A00"/>
  </svg>
);

const DeliveryIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 12h24v20H8z" stroke="#FF7A00" strokeWidth="2" fill="none"/>
    <path d="M32 20h6l2 4v8h-8" stroke="#FF7A00" strokeWidth="2" fill="none"/>
    <circle cx="14" cy="36" r="4" stroke="#FF7A00" strokeWidth="2" fill="none"/>
    <circle cx="34" cy="36" r="4" stroke="#FF7A00" strokeWidth="2" fill="none"/>
    <path d="M18 36h16" stroke="#FF7A00" strokeWidth="2"/>
  </svg>
);

const DollarIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="20" stroke="#FF7A00" strokeWidth="2" fill="none"/>
    <path d="M24 8v32M16 16h12a4 4 0 0 1 0 8h-8m0 0h8a4 4 0 0 1 0 8H16" stroke="#FF7A00" strokeWidth="2"/>
  </svg>
);

const MessageIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 12h32a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H16l-8 8V16a4 4 0 0 1 4-4z" stroke="#FF7A00" strokeWidth="2" fill="none"/>
    <path d="M16 24h16M16 20h16M16 28h8" stroke="#FF7A00" strokeWidth="2"/>
  </svg>
);

const ProducerFeatures = () => {
  return (
    <FeaturesContainer>
      <FeaturesContent>
        <TitleContainer>
          <Title>Ventajas exclusivas de <strong>Floqss</strong></Title>
          <TitleArrow />
        </TitleContainer>
        
        <CardsContainer>
          <FeatureCard>
            <IconContainer>
              <PaymentIcon />
            </IconContainer>
            <FeatureTitle>Acceso desbloqueado</FeatureTitle>
            <FeatureDescription>
              Llegas a millones que solo compran pagando en efectivo, al recibir. Sin tarjetas. Sin registros bancarios. Sin fricciones.
            </FeatureDescription>
          </FeatureCard>
          
          <FeatureCard>
            <IconContainer>
              <DeliveryIcon />
            </IconContainer>
            <FeatureTitle>Logística integrada</FeatureTitle>
            <FeatureDescription>
              Floqss coordina automáticamente el envío con las principales transportadoras del país. Tú eliges, nosotros conectamos. Tus productos llegan sin que tengas que preocuparte.
            </FeatureDescription>
          </FeatureCard>
          
          <FeatureCard>
            <IconContainer>
              <DollarIcon />
            </IconContainer>
            <FeatureTitle>Modelo justo</FeatureTitle>
            <FeatureDescription>
              Sin mensualidades. Sin tarifas escondidas. Nuestra comisión solo se aplica si la venta se concreta exitosamente. Así de simple, así de justo.
            </FeatureDescription>
          </FeatureCard>
          
          <FeatureCard>
            <IconContainer>
              <MessageIcon />
            </IconContainer>
            <FeatureTitle>Propósito real</FeatureTitle>
            <FeatureDescription>
              Cada venta no solo genera ingresos. Abres puertas, llevas educación y oportunidades a millones que siempre fueron ignorados.
            </FeatureDescription>
          </FeatureCard>
        </CardsContainer>
      </FeaturesContent>
    </FeaturesContainer>
  );
};

export default ProducerFeatures;